import store from '@/store';

export default (to, from, next) => {
    store.dispatch('get_is_module_ufb_enabled').catch(() => {});

    const allow = store.getters.is_show_ufb_module;

    return {
        allow,
        redirect: { name: 'not-found' },
    };
}